import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";

const ConvertToOrder = ({ show, onClose, onConfirm, isPORequired, loading = false }) => {
  const [installDate, setInstallDate] = useState("");
  const [purchaseOrder, setPurchaseOrder] = useState("");
  const [occupied, setOccupied] = useState("No");

  // Today's date (yyyy-MM-dd, local) used to block selecting past dates.
  const today = new Date().toLocaleDateString("en-CA");

  const handleConfirm = () => {
    if (!installDate) return; // install date required to become a real order
    if (installDate < today) return; // block past dates (e.g. typed manually)
    onConfirm({ installDate, purchaseOrder, occupied: occupied === "Yes" });
  };

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Convert to Order</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Estimated Installation Date<span style={{"color":"red"}}>*</span></Form.Label>
          <Form.Control type="date" min={today} value={installDate} onChange={(e) => setInstallDate(e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label style={isPORequired ? {'color': 'red'}: {}}>Purchase Order#{isPORequired && <span id="requirePOToInstall" style={{"color":"red"}}>*</span>}</Form.Label>
          <Form.Control type="text" value={purchaseOrder} onChange={(e) => setPurchaseOrder(e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Occupied?</Form.Label>
          <Form.Select value={occupied} onChange={(e) => setOccupied(e.target.value)}>
            <option value="No">No</option>
            <option value="Yes">Yes</option>
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>Cancel</Button>
        <Button variant="primary" onClick={handleConfirm} disabled={(isPORequired && purchaseOrder.trimStart()==='') || !installDate || loading}>
          {loading ? "Converting..." : "Convert"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConvertToOrder;
